module.exports = {
    Superliga: `@font-face {
            font-family: 'Superliga';
            font-style: normal;
            font-weight: normal;
            src: url('https://cdn.tjekscores.dk/static/fonts/superliga/superliga-sans.woff2') format('woff2'),
                 url('https://cdn.tjekscores.dk/static/fonts/superliga/superliga-sans.woff') format('woff'),
                 url('https://cdn.tjekscores.dk/static/fonts/superliga/superliga-sans.ttf') format('truetype');
        }`,
    Gotham: `@font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-weight: 400;
            src: url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-book.woff2') format('woff2'),
                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-book.woff') format('woff'),
                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-book.ttf') format('truetype');
        }
        @font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-weight: 300;
            src: url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-light.woff2') format('woff2'),
                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-light.woff') format('woff'),
                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-light.ttf') format('truetype');
        }
        @font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-weight: bold;
            src: url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-bold.woff2') format('woff2'),
                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-bold.woff') format('woff'),
                 url('https://cdn.tjekscores.dk/static/fonts/gotham/gotham-bold.ttf') format('truetype');
        }`,
    Flama: `@font-face {
            font-family: 'Flama';
            font-style: normal;
            font-weight: 400;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-basic.otf') format('opentype');
        }
        @font-face {
            font-family: 'Flama';
            font-style: normal;
            font-weight: 300;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-light.otf') format('opentype');
        }
        @font-face {
            font-family: 'Flama';
            font-style: normal;
            font-weight: 700;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-bold.otf') format('opentype');
        }
        @font-face {
            font-family: 'Flama';
            font-style: normal;
            font-weight: 800;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-extrabold.otf') format('opentype');
        }`,
    FlamaUltracondensed: `
        @font-face {
            font-family: 'FlamaUltracondensed';
            font-style: normal;
            font-weight: 400;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-ultracondensed-basic.otf') format('opentype');
        }
        @font-face {
            font-family: 'FlamaUltracondensed';
            font-style: normal;
            font-weight: 300;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-ultracondensed-light.otf') format('opentype');
        }
        @font-face {
            font-family: 'FlamaUltracondensed';
            font-style: normal;
            font-weight: 700;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-ultracondensed-bold.otf') format('opentype');
        }
        `,
    FlamaSemicondensed: `
        @font-face {
            font-family: 'FlamaSemicondensed';
            font-style: normal;
            font-weight: 400;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-semicondensed-book.otf') format('opentype');
        }
        @font-face {
            font-family: 'FlamaSemicondensed';
            font-style: normal;
            font-weight: 700;
            src: url('https://cdn.tjekscores.dk/static/fonts/flama/flama-semicondensed-bold.otf') format('opentype');
        }
        `,
    MuseoSans: `
        @font-face {
            font-family: 'MuseoSans';
            font-style: normal;
            font-weight: 100;
            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_100.otf') format('truetype');
        }
        @font-face {
            font-family: 'MuseoSans';
            font-style: normal;
            font-weight: 300;
            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_300.otf') format('truetype');
        }
        @font-face {
            font-family: 'MuseoSans';
            font-style: normal;
            font-weight: 500;
            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_500.otf') format('truetype');
        }
        @font-face {
            font-family: 'MuseoSans';
            font-style: normal;
            font-weight: 700;
            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_700.otf') format('truetype');
        }
        @font-face {
            font-family: 'MuseoSans';
            font-style: normal;
            font-weight: 900;
            src: url('https://cdn.tjekscores.dk/static/fonts/museo/MuseoSans_900.otf') format('truetype');
        }
        `,
    ProximaNova: `
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 100;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedThin.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 300;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedLight.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 400;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedRegular.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 500;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedMedium.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 600;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedSemibild.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 700;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedBold.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 800;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedExtrabold.otf') format('truetype');
        }
        @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-weight: 900;
            src: url('https://cdn.tjekscores.dk/static/fonts/proxima/ProximaNovaCondensedBlack.otf') format('truetype');
        }
        `,
    FuturaBold: `
        @font-face {
            font-family: 'FuturaBold';
            font-style: normal;
            font-weight: 700;
            src: url('https://cdn.tjekscores.dk/static/fonts/futura/Futura+Bold.otf') format('truetype');
        }
        `,
};



/** WEBPACK FOOTER **
 ** ../src/widgets/fonts/index.js
 **/